import * as Sentry from '@sentry/react';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

import Version from '../app-v2/components/version';

import AnalyticsContextProvider from './analytics';
import { ErrorFallback } from './components/error-fallback/error-fallback';
import { Loading } from './components/loading/loading';
import { Paths } from './constants/paths';
import CRApp from './pages/cr-app';
import { ErrorPage, PageNotFound } from './pages/not-found/error-page';
import { Privacy } from './pages/privacy';
import { TermsAndConditions } from './pages/terms';

const GlobalStyle = createGlobalStyle`
  html,body {
    margin:0;
    padding:0;
    font-family: 'Space Grotesk', 'Open Sans', sans-serif;
    scroll-behavior: smooth;
  }

  button {
    font-family: 'Space Grotesk', 'Open Sans', sans-serif;
  }
`;

export const App: React.FC = () => {
  return (
    <React.Suspense fallback={<Loading />}>
      <AnalyticsContextProvider
        platform={'segment'}
        writeKey={import.meta.env.REACT_APP_SEGMENT_WRITE_KEY || ''}
      >
        <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => (
            <ErrorFallback error={error as string} resetErrorBoundary={resetError} />
          )}
        >
          <GlobalStyle />
          <Version>
            <Routes>
              <Route path={Paths.HOME} element={<Navigate to="/app/redirect" replace />} />
              <Route path={Paths.PRIVACY_POLICY} element={<Privacy />} />
              <Route path={Paths.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
              <Route path={'app/*'} element={<CRApp />} />
              <Route
                path={Paths.NOT_FOUND}
                element={
                  <ErrorPage>
                    <PageNotFound />
                  </ErrorPage>
                }
              />
            </Routes>
          </Version>
        </Sentry.ErrorBoundary>
      </AnalyticsContextProvider>
    </React.Suspense>
  );
};

export default App;
